<div class="contractor-list-main-container">
  <div class="overlay" *ngIf="opened"></div>
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorDashboard()">
    {{ ContractorListEnum.Breadcrumb }}
  </span>
  </div>
  <div class="contractor-list-container">
    <div class="contractor-search-table-container">
      <div class="contractor-list-search">
        <div class="contractor-title">
          <span>{{ ContractorListEnum.ListOfContractors }} ({{ totalCount }})</span>
        </div>
        <div class="search-bar-container">
          <div class="search-child">
            <emerald-input
              [label]="ContractorListEnum.SearchLabel"
              [trailingIcon]="'search'"
              (keyup)="searchContractors($event)"
              [value]="filterValue"
              ><emerald-icon
                *ngIf="filterValue?.length"
                [icon]="'close'"
                (click)="clearInput()"
              ></emerald-icon>
            </emerald-input>
          </div>
          <div class="filter-child">
            <emerald-menu
              [opened]="opened"
              [position]="'bottom_end'"
              [targetElement]="navTemplate"
              [menuTemplate]="menuTemplate"
              (openChange)="opened = $event"
            ></emerald-menu>
            <ng-template #navTemplate>
              <emerald-button
                [label]="ContractorListEnum.FilterLabel"
                [size]="'Small'"
                [type]="'Secondary'"
                [icon]="'filter_list'"
                [iconPosition]="'Left'"
                (onClick)="toggleFilter()"
              ></emerald-button>
            </ng-template>
            <ng-template #menuTemplate>
              <app-contractor-list-filter
                [ContractorDataByFilter]="contractorsvendorView"
                (filterApplied)="onFilterApplied($event)"
                (filterReset)="onFilterReset()"
                (closeFilter)="closeFilter()"
              ></app-contractor-list-filter>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="contractor-list-table">
        <ng-container *ngIf="displayData?.length; else noDataTemplate">
          <emerald-datatable
            [columnDefs]="columnDefs"
            [rowData]="displayData"
            [paginationParams]="paginationParams"
            [customCellTemplate]="{
              contractorName: customContractorNameColumn
            }"
          >
          </emerald-datatable>
        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <ng-container *ngIf="isDataLoaded">
                <h2 class="empty-state-title">{{ ContractorListEnum.NoRecordsTitle }}</h2>
              </ng-container>
              <img
                [src]="imageSrc"
                [alt]="ContractorListEnum.NoRecordsAltText"
                class="empty-state-image"
              />
            </div>
          </section>
        </ng-template>
      </div>
    </div>
  </div>
</div>
